import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { fetchProducts } from 'catalog/actions/product';
import { createEntityNode } from 'catalog/actions/node';
import NodeSourcePage from './NodeSourcePage';

const mapStateToProps = state => ({
  entities: state.catalog.products,
  info: 'Sélectionnez un produit pour créer un noeud à partir de ce dernier.',
  link: '/products/new',
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchEntities: () => dispatch(fetchProducts()),
  createNode: product =>
    dispatch(
      createEntityNode(ownProps.catalog, ownProps.params.id, 'product', product)
    ),
  redirectToParent: () => dispatch(replace(`/nodes/${ownProps.params.id}`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NodeSourcePage);



// WEBPACK FOOTER //
// ./src/modules/catalog/pages/NodeProductsPage.js